import { RadioButton } from 'primereact/radiobutton';
import { classNames } from 'primereact/utils';
import type { ReactNode } from 'react';
import style from '../views/program.module.css';
import { cn } from '@/components/ui/cn';

type Program = {
	icon: ReactNode;
	title: string;
	value: string;
	description: string;
};

type Props = {
	programs: Program[];
	handleChange: (value: string) => void;
	program: string;
};

const SelectProgram = (props: Props) => {
	const { programs, program, handleChange } = props;

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' || e.key === ' ') {
			handleChange(program);
		}
	};

	return (
		<div className="flex flex-col">
			<div className="grid grid-cols-1 md:grid-cols-2 gap-5">
				{programs.map((prog) => {
					const isChecked = program === prog.value;

					return (
						<div
							key={prog.value}
							className={cn(
								'flex flex-col space-y-2 bg-surfaceContainer rounded-[28px] p-4',
								isChecked && 'shadow-[inset_0_0_0_2px_theme(colors.primary60)]'
							)}
							onClick={() => handleChange(prog.value)}
							onKeyDown={handleKeyDown} // Handle keyboard events
						>
							<div className="flex justify-between items-center">
								<img
									alt={prog.value}
									src={'/images/svg/blue-car.svg'}
									height={48}
									width={48}
								/>
								<RadioButton
									onChange={() => handleChange(prog.value)}
									checked={isChecked}
									value={prog.value}
									className="self-end my-3.5 mr-3.5"
									pt={{
										box: { className: cn('border-2 duration-200', isChecked ? 'border-primary' : 'border-neutralVariant20') },
										icon: { className: 'bg-primary' },
									}}
								/>
							</div>
							<div className="space-y-3">
								<span className="text-headline-x-small font-semibold text-primary">
									{prog.title}
								</span>
								<p className="text-body-medium text-sm">
									{prog.description}
								</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default SelectProgram;
